<template>
    <div>
      <!-- <label for="pacViewPlace">COGNEETIV MAP</label> -->
      <input
        type="text"
        id="pacViewPlace"
        placeholder="Enter a location..."
        @keyup.enter="place_changed"
        style="width: 100%; margin-bottom: 0px; top: 100px; background-color: #0a0a0a; color: aliceblue; font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;"
      />
      <v-btn @click="place_changed">Submit</v-btn>
      <div id="cesiumContainer"></div>
    </div>
  </template>
  
  <script>
  /* global Cesium, google */ // This tells ESLint that Cesium and google are global variables
  
  export default {
    name: "CesiumMap",
    data() {
      return {
        viewer: null
      };
    },
    mounted() {
      this.initCesium();
      this.loadGoogleMapsApi();
    },
    methods: {
      initCesium() {
        Cesium.RequestScheduler.requestsByServer["tile.googleapis.com:443"] = 20;
  
        this.viewer = new Cesium.Viewer("cesiumContainer", {
          imageryProvider: false,
          baseLayerPicker: false,
          requestRenderMode: true,
          geocoder: false,
          globe: false
        });
  
        this.viewer.scene.primitives.add(
          new Cesium.Cesium3DTileset({
            url: "https://tile.googleapis.com/v1/3dtiles/root.json?key=AIzaSyB3Vn2Bmfyw9gLbnRnEgwC92LBZdaWXzC8",
            showCreditsOnScreen: true
          })
        );
        // this.initAutocomplete();
  
        this.flyToUserLocation();
      },
      loadGoogleMapsApi() {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyB3Vn2Bmfyw9gLbnRnEgwC92LBZdaWXzC8&libraries=places&callback=initAutocomplete";
        script.async = true;
        document.body.appendChild(script);
        window.initAutocomplete = this.initAutocomplete;
      },
      flyToUserLocation() {
        navigator.geolocation.getCurrentPosition(position => {
          this.viewer.camera.flyTo({  // changed `viewer` to `this.viewer`
              destination: Cesium.Cartesian3.fromDegrees(
                  position.coords.longitude,
                  position.coords.latitude,
                  300.0
              ),
              orientation: {
                  pitch: Cesium.Math.toRadians(-25.0),
              },
              complete: function() {
                  setTimeout(() => {
                      this.viewer.camera.flyHome();  // changed `viewer` to `this.viewer`
                      alert('Enter Location you want to see');
                  }, 15000);
              }.bind(this) // To retain the value of this inside the function
          });
        });
      },
      zoomToViewport(viewport) {
        let polylineEntity = this.viewer.entities.add({
          polyline: {
              positions: Cesium.Cartesian3.fromDegreesArray([
                  viewport.getNorthEast().lng(), viewport.getNorthEast().lat(),
                  viewport.getSouthWest().lng(), viewport.getNorthEast().lat(),
                  viewport.getSouthWest().lng(), viewport.getSouthWest().lat(),
                  viewport.getNorthEast().lng(), viewport.getSouthWest().lat(),
                  viewport.getNorthEast().lng(), viewport.getNorthEast().lat(),
              ]),
              width: 5,
              clampToGround: true,
              material: Cesium.Color.BLUE,
          },
        });
  
        this.viewer.flyTo(polylineEntity, {
          offset: {
              heading: 0,
              pitch: Cesium.Math.toRadians(-25.0),
              range: 300.0  // This might need to be adjusted depending on your needs.
          }
        });
      },
      initAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(
         document.getElementById("pacViewPlace"),
         {
           fields: ["geometry", "name"],
         }
       );
       autocomplete.addListener("place_changed", () => {
         this.viewer.entities.removeAll();
         const place = autocomplete.getPlace();
         if (!place.geometry || !place.geometry.viewport) {
           window.alert("No viewport for input: " + place.name);
           return;
         }
         this.zoomToViewport(place.geometry.viewport);  // changed `zoomToViewport` to `this.zoomToViewport`
       });
      },
      setupVoiceRecognition() {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (SpeechRecognition) {
          this.recognition = new SpeechRecognition();
          this.recognition.continuous = false;
          this.recognition.lang = 'en-US';
          this.recognition.interimResults = false;
          this.recognition.maxAlternatives = 1;
  
          this.recognition.onresult = (event) => {
            const last = event.results.length - 1;
            const text = event.results[last][0].transcript;
            document.getElementById("pacViewPlace").value = text;
            this.submitForm();
          };
  
          this.recognition.onspeechend = () => {
            this.isRecording = false;
            this.recognition.stop();
          };
  
          this.recognition.onerror = (event) => {
            console.error("SpeechRecognition error: ", event.error);
            this.isRecording = false;
          };
        }
      },
  
      startVoiceRecognition() {
        if (this.recognition && !this.isRecording) {
          this.isRecording = true;
          this.recognition.start();
        }
      },
  
  
  
      searchLocation(location, callback) {
      // Placeholder for searching a location
      // Implement your location search logic here
      console.log("Searching for location:", location);
  
      // Simulate asynchronous action with setTimeout
      setTimeout(() => {
        // Call the callback function once the search is complete
        if (callback && typeof callback === 'function') {
          callback();
        }
      }, 2000); // Simulating a 2-second search process
    },
  
    // initAutocomplete() {
    //   // Assuming you've already loaded the Google Maps API
    //   const input = document.getElementById('pacViewPlace');
    //   const autocomplete = new google.maps.places.Autocomplete(input, {
    //     fields: ['geometry', 'name']
    //   });
  
    //   autocomplete.addListener('place_changed', () => {
    //     const place = autocomplete.getPlace();
    //     if (!place.geometry) {
    //       window.alert("No details available for input: '" + place.name + "'");
    //       return;
    //     }
  
    //     // You can use place.geometry.location here to get the coordinates
    //     console.log("Location coordinates:", place.geometry.location.toString());
  
    //     // Here you might want to do something with the selected location
    //     // For example, zoom to the location on the map
    //     // this.zoomToLocation(place.geometry.location);
    //   });
    // },
    }
  };
  </script>
  
  <style scoped>
  .cesium-viewer-toolbar {
    display: none;
  }
  #cesiumContainer {
    height: 100vh;
    width: 100vw;
  }
  </style>
  